// WHY: a declined undo comes back as plain chat-text, so only a save or a typed revert names agreements that moved
export const assistantEnvelopeUpdates = (message)=>{
    var _message_appliedIds;
    return {
        filterUpdate: message.persistedAgreementFilterUpdate(),
        selectionUpdate: message.persistedSelectionUpdate(),
        changedAgreementIds: (_message_appliedIds = message.appliedIds()) !== null && _message_appliedIds !== void 0 ? _message_appliedIds : message.revertedItemIds()
    };
};
